export interface CreativeMediaReadTask {
  abort(): void;
  settled: Promise<{ continuePolling: boolean; failed?: boolean }>;
}

/** 一个会话一次读取；中止请求 settle 后才能恢复，避免隐藏/切换时叠加分页。 */
export class CreativeMediaProgressScheduler {
  private timer: ReturnType<typeof setTimeout> | null = null;
  private task: CreativeMediaReadTask | null = null;
  private paused = false;
  private disposed = false;
  private requested = false;
  private failures = 0;
  constructor(private readonly read: () => CreativeMediaReadTask) {}

  requestNow() {
    if (this.disposed) return;
    this.clearTimer();
    this.requested = true;
    this.start();
  }
  pause() {
    this.paused = true;
    this.clearTimer();
    this.task?.abort();
  }
  resume() {
    this.paused = false;
    this.requestNow();
  }
  dispose() {
    this.disposed = true;
    this.clearTimer();
    this.task?.abort();
  }
  private clearTimer() {
    if (this.timer !== null) clearTimeout(this.timer);
    this.timer = null;
  }
  private start() {
    if (this.disposed || this.paused || this.task || !this.requested) return;
    this.requested = false;
    const task = this.read();
    this.task = task;
    void task.settled.then((result) => {
      this.failures = result.failed ? this.failures + 1 : 0;
      return result;
    }, () => {
      this.failures += 1;
      return { continuePolling: true, failed: true };
    }).then((result) => {
      this.task = null;
      if (this.disposed || this.paused) return;
      if (this.requested) { this.start(); return; }
      if (result.continuePolling) {
        this.timer = setTimeout(() => this.requestNow(), Math.min(15000, 3000 * 2 ** this.failures));
      }
    });
  }
}
